export default __webpack_public_path__ + "static/media/default-user.e85b4b75.png";